var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"file",on:{"click":function($event){return _vm.$refs.input.click()}}},[_vm._v("\n  "+_vm._s(this.name || _vm.$t("CHOOSE_FILE"))+"\n  "),_c('input',{ref:"input",staticClass:"input",attrs:{"type":"file"},on:{"change":_vm.onChange}})])
}
var staticRenderFns = []

export { render, staticRenderFns }